import { render, staticRenderFns } from "./MoleculeEquipmentResource.vue?vue&type=template&id=05327de2&scoped=true&"
import script from "./MoleculeEquipmentResource.vue?vue&type=script&lang=js&"
export * from "./MoleculeEquipmentResource.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeEquipmentResource.vue?vue&type=style&index=0&id=05327de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05327de2",
  null
  
)

export default component.exports